// extracted by mini-css-extract-plugin
export default {"ljiRed":"#ee2346","rowWarning":"RecurringTaskSchedulesGrid_rowWarning__gzN4O"};